import { FC } from "react"
import cx from "classnames"
import { AiOutlineClose } from "react-icons/ai"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const CloseIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <AiOutlineClose
      className={cx("w-5 h-5 active:scale-90", className)}
      {...rest}
    />
  )
}

export default CloseIcon
